var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-pdf-app',{attrs:{"tabIndex":"0","pdf":_vm.pdf,"config":_vm.config},on:{"open":_vm.openHandler,"pages-rendered":_vm.pagesRenderedHandler,"after-created":_vm.afterCreatedHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }